export default __webpack_public_path__ + "static/media/C.23788e7b.png";